import { useMemo } from 'react'

import { createUnitFormatters, DEFAULT_UNIT_SYSTEM } from '@/lib/format'
import type { UnitFormatters, UnitSystem } from '@/lib/format'
import { useActivityStore } from '@/store/activity-store'

/** The display unit system (persisted `ui.units`; absent = metric). Display only -- never affects stored data or exports. */
export function useUnits(): UnitSystem {
  return useActivityStore((s) => s.ui.units ?? DEFAULT_UNIT_SYSTEM)
}

/** Distance/elevation/speed/pace formatters bound to the current display unit system. */
export function useUnitFormatters(): UnitFormatters {
  const units = useUnits()
  return useMemo(() => createUnitFormatters(units), [units])
}
